/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Gameawards_Videotitle2Inputs */

const id_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Siaran Langsung`)
};

const ms_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Siaran Langsung`)
};

const da_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Live Stream`)
};

const de_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Livestream`)
};

const en_us2_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Live Stream`)
};

const es_es2_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Transmisión en vivo`)
};

const es_mx2_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Transmisión en vivo`)
};

const fil_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Live Stream`)
};

const fr_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 — En direct`)
};

const it_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Live Stream`)
};

const hu_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Élő közvetítés`)
};

const nl_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Live Stream`)
};

const no_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Direktesendt`)
};

const pl_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Transmisja na żywo`)
};

const pt_br2_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Transmissão ao vivo`)
};

const pt_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Transmissão ao vivo`)
};

const ro_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Transmisiune în direct`)
};

const fi_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Live-lähetys`)
};

const sv_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Live-sändning`)
};

const vi_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Phát trực tiếp`)
};

const tr_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Canlı Yayın`)
};

const cs_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Živý přenos`)
};

const bg_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - На живо`)
};

const ru_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 — Прямая трансляция`)
};

const uk_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - Прямий ефір`)
};

const ar_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - البث المباشر`)
};

const hi_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`द गेम अवार्ड्स 2024 - लाइव स्ट्रीम`)
};

const th_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - ถ่ายทอดสด`)
};

const ja_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - ライブ配信`)
};

const zh_cn2_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - 直播`)
};

const zh_hant1_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - 直播`)
};

const ko_misc_gameawards_videotitle2 = /** @type {(inputs: Misc_Gameawards_Videotitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 2024 - 라이브 스트림`)
};

/**
* | output |
* | --- |
* | "The Game Awards 2024 - Live Stream" |
*
* @param {Misc_Gameawards_Videotitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_gameawards_videotitle2 = /** @type {((inputs?: Misc_Gameawards_Videotitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Gameawards_Videotitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_gameawards_videotitle2(inputs)
	if (locale === "ms") return ms_misc_gameawards_videotitle2(inputs)
	if (locale === "da") return da_misc_gameawards_videotitle2(inputs)
	if (locale === "de") return de_misc_gameawards_videotitle2(inputs)
	if (locale === "en-US") return en_us2_misc_gameawards_videotitle2(inputs)
	if (locale === "es-ES") return es_es2_misc_gameawards_videotitle2(inputs)
	if (locale === "es-MX") return es_mx2_misc_gameawards_videotitle2(inputs)
	if (locale === "fil") return fil_misc_gameawards_videotitle2(inputs)
	if (locale === "fr") return fr_misc_gameawards_videotitle2(inputs)
	if (locale === "it") return it_misc_gameawards_videotitle2(inputs)
	if (locale === "hu") return hu_misc_gameawards_videotitle2(inputs)
	if (locale === "nl") return nl_misc_gameawards_videotitle2(inputs)
	if (locale === "no") return no_misc_gameawards_videotitle2(inputs)
	if (locale === "pl") return pl_misc_gameawards_videotitle2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_gameawards_videotitle2(inputs)
	if (locale === "pt") return pt_misc_gameawards_videotitle2(inputs)
	if (locale === "ro") return ro_misc_gameawards_videotitle2(inputs)
	if (locale === "fi") return fi_misc_gameawards_videotitle2(inputs)
	if (locale === "sv") return sv_misc_gameawards_videotitle2(inputs)
	if (locale === "vi") return vi_misc_gameawards_videotitle2(inputs)
	if (locale === "tr") return tr_misc_gameawards_videotitle2(inputs)
	if (locale === "cs") return cs_misc_gameawards_videotitle2(inputs)
	if (locale === "bg") return bg_misc_gameawards_videotitle2(inputs)
	if (locale === "ru") return ru_misc_gameawards_videotitle2(inputs)
	if (locale === "uk") return uk_misc_gameawards_videotitle2(inputs)
	if (locale === "ar") return ar_misc_gameawards_videotitle2(inputs)
	if (locale === "hi") return hi_misc_gameawards_videotitle2(inputs)
	if (locale === "th") return th_misc_gameawards_videotitle2(inputs)
	if (locale === "ja") return ja_misc_gameawards_videotitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_gameawards_videotitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_gameawards_videotitle2(inputs)
	return ko_misc_gameawards_videotitle2(inputs)
});
export { misc_gameawards_videotitle2 as "misc.gameAwards.videoTitle" }